export enum StockRuleType {
  MinimumStock = 1,
}
